import {
    FETCH_INVOICE_DATA_REQUEST,
      FETCH_INVOICE_DATA_SUCCESS,
      FETCH_INVOICE_DATA_FAILURE,
    } from "./FetchInvoiceDataTypes";
    import api from "../../utils/Api";
    
    export const fetchInvoiceDataRequest = () => {
      return {
        type: FETCH_INVOICE_DATA_REQUEST,
      };
    };
    
    export const fetchInvoiceDataSuccess = (invoiceData) => {
      return {
        type: FETCH_INVOICE_DATA_SUCCESS,
        payload: invoiceData,
      };
    };
    
    export const fetchInvoiceDataFailure = (error) => {
      return {
        type: FETCH_INVOICE_DATA_FAILURE,
        payload: error,
      };
    };
    
    export const fetchInvoiceData = (invoice_id) => {
      
      const headers = {
        Authorization:
          "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
      };
      let url = `payment/invoice/`+invoice_id;
    
      
      return async (dispatch) => {
        dispatch(fetchInvoiceDataRequest);
        try {
          const response = await api.get(url,
            {
              headers: headers,
            }
          );
          const invoiceData = response.data.data;
          //console.log("initialNotesData", initialNotesData)
          dispatch(fetchInvoiceDataSuccess(invoiceData));
        } catch (error) {
          console.log("Redux error - ", error.response);
          const errorMsg = error.message;
          dispatch(fetchInvoiceDataFailure(errorMsg));
        }
      };
    };
    